export enum FancyFieldStyles {
  Bold = 'Bold',
  Highlight = 'Highlight',
}
